import React from 'react'
import Title from '../../../../../../components/typography/title.component.jsx'
import Container from '../../../../../../components/layout/container.component.jsx'
import SearchForm from '../../components/search-form.component'
import FontAwesome from 'react-fontawesome'
import AccordionSecondary from '../../../../../../components/accordion/accordion-secondary.component.jsx'
import PaginationComponent from '../../../../../../components/pagination/pagination.component.jsx'
import { PRIMARY_COLOR } from '../../../../../../styles/colors.style'
import { routes } from '../../../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from './../../../../../../actions'
import { bindActionCreators } from 'redux'
import { StoreProductService } from './../../../../../../services/store-product.service'
import { Creators as SiteCreators } from '../../../../../../ducks/site/site'

class StoreProductSearchPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			name: '',
			active: '',
		}

		this.toggleProduct = toggleProduct.bind(this)
		this.getAccordionItems = getAccordionItems.bind(this)
		this.toggleProductFlag = toggleProductFlag.bind(this)
		this.paginationRenderRow = paginationRenderRow.bind(this)
		this.toggleProductSpotlight = toggleProductSpotlight.bind(this)
	}

	componentDidUpdate(prevProps) {
		if (prevProps.loading && !this.props.loading) {
			this.refs.pagination.reload()
		}
	}

	componentDidMount() {
		this.refs.pagination.reload()
	}

	render() {
		const { active, name } = this.state
		return (
			<Container medium>
				<Title>Produtos Loja Muviflex</Title>
				<AccordionSecondary
					noAnimated
					noClickable
					arrow={false}
					multiple={false}
					items={this.getAccordionItems()}
				/>
				<div data-permission="E2DBE8A95933AFBC05AE2B3B04B006C5B42B5A0B">
					<PaginationComponent
						params={{
							active,
							name,
						}}
						ref={'pagination'}
						rowsPerPage={50}
						headers={paginationHeaders}
						sortable={paginationSortable}
						getData={StoreProductService.search}
						renderRow={this.paginationRenderRow}
					/>
				</div>
			</Container>
		)
	}
}

const paginationHeaders = [
	{ header: 'Nome', key: 'name' },
	{ header: 'Quantidade', key: 'quantity', align: 'center' },
	{ header: 'Situação', key: 'active', align: 'center' },
	{ header: 'Destaque', key: 'spotlight', align: 'center' },
]

const paginationSortable = {
	defaultOrder: 'asc',
	cols: [
		{ key: 'name' },
		{ key: 'quantity' },
		{ key: 'active' },
		{ key: 'spotlight' },
	],
}

function getAccordionItems() {
	return [
		{
			title: 'Filtros',
			content: (
				<SearchForm
					ref={'form'}
					history={this.props.history}
					onSubmit={handleSubmit.bind(this)}
				/>
			),
		},
	]
}

function paginationRenderRow(rowData, headers) {
	return headers.map(({ key }) => {
		const isKeyName = key == 'name'
		const cellData = rowData[key]
		const productId = rowData.id
		const textAlign = isKeyName ? 'left' : 'center'

		switch (key) {
			case 'active':
				const isActive = rowData.active
				return (
					<td key={key} align={textAlign}>
						<FontAwesome
							onClick={(e) => {
								e.stopPropagation()
								this.toggleProduct(productId, isActive)
							}}
							size="lg"
							style={isActive ? { color: PRIMARY_COLOR } : {}}
							name={isActive ? 'toggle-on' : 'toggle-off'}
							title={isActive ? 'Produto ativo' : 'Produto inativo'}
						/>
					</td>
				)
			case 'spotlight':
				const isSpotlight = rowData.spotlight
				return (
					<td key={key} align={textAlign}>
						<FontAwesome
							onClick={(e) => {
								e.stopPropagation()
								this.toggleProductSpotlight(productId, isSpotlight)
							}}
							size="lg"
							style={isSpotlight ? { color: PRIMARY_COLOR } : {}}
							name={isSpotlight ? 'toggle-on' : 'toggle-off'}
							title={
								isSpotlight
									? 'Produto em destaque'
									: 'Produto não destacado'
							}
						/>
					</td>
				)
			default:
				const text =
					isKeyName && cellData.length > 64
						? cellData.substr(0, 61) + '...'
						: cellData
				return (
					<td
						key={key}
						style={{ textAlign }}
						onClick={viewProduct.bind(this, productId)}>
						<span title={cellData}>{text}</span>
					</td>
				)
		}
	})
}

function toggleProductFlag(productId, flag, setFlagData, unsetFlagData) {
	const { showLoading, hideLoading, toastSuccess, toastError } = this.props
	showLoading()
	if (flag) {
		unsetFlagData
			.endpoint(productId)
			.then(({ success, errors }) => {
				hideLoading()
				if (success) {
					toastSuccess({
						message: unsetFlagData.successMessage,
					})
					this.refs.pagination.reload()
				} else
					toastError({
						message: errors.pop(),
					})
			})
			.catch(() => {
				hideLoading()
				toastError({
					message: unsetFlagData.failureMessage,
				})
			})
	} else {
		setFlagData
			.endpoint(productId)
			.then(({ success, errors }) => {
				hideLoading()
				if (success) {
					toastSuccess({ message: setFlagData.successMessage })
					this.refs.pagination.reload()
				} else
					toastError({
						message: errors.pop(),
					})
			})
			.catch(() => {
				hideLoading()
				toastError({
					message: setFlagData.failureMessage,
				})
			})
	}
}

function toggleProductSpotlight(productId, isSpotlight) {
	this.toggleProductFlag(
		productId,
		isSpotlight,
		{
			endpoint: StoreProductService.spotlight,
			successMessage: 'Produto destacado com sucesso',
			failureMessage:
				'Não foi possível destacar o produto, por favor tente novamente mais tarde',
		},
		{
			endpoint: StoreProductService.removeSpotlight,
			successMessage: 'Produto removido de destaque com sucesso',
			failureMessage:
				'Não foi possível remover o destaque do produto, por favor tente novamente mais tarde',
		}
	)
}

function toggleProduct(productId, isActive) {
	this.toggleProductFlag(
		productId,
		isActive,
		{
			endpoint: StoreProductService.activate,
			successMessage: 'Produto ativado com sucesso',
			failureMessage:
				'Não foi possível ativar o produto, por favor tente novamente mais tarde',
		},
		{
			endpoint: StoreProductService.deactivate,
			successMessage: 'Produto inativado com sucesso',
			failureMessage:
				'Não foi possível inativar o produto, por favor tente novamente mais tarde',
		}
	)
}

function viewProduct(productId) {
	this.props.history.push(`${routes.ADMIN}/loja-moveflex/${productId}`)
}

function handleSubmit({ active, name }) {
	this.setState(
		{
			active,
			name,
		},
		() => this.refs.pagination.reload()
	)
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
		},
		dispatch
	)

const connectedStoreProductSearchPageComponent = withRouter(
	connect(null, mapDispatchToProps)(StoreProductSearchPageComponent)
)

export { connectedStoreProductSearchPageComponent as ModuleRootComponent }
